import { Phone, Mail, MapPin, Shield } from "lucide-react";
import { companyInfo } from "../data";
import ContactForm from "../components/ContactForm";
import useMetadata from "../hooks/useMetadata";

export default function Contact() {
  useMetadata(
    "Kontakt os",
    "Kontakt Godske Byg & Anlæg i dag for et uforpligtende tilbud på jord-, grave- eller anlægsarbejde. Ring på 22 26 28 27 eller send en besked."
  );

  return (
    <div className="bg-white text-brand-charcoal min-h-[80vh]">
      {/* Contact Content Section */}
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
            {/* Left Column: Contact Info */}
            <div className="lg:col-span-5 space-y-8">
              <div>
                <h2 className="font-display text-2xl font-bold text-brand-charcoal sm:text-3xl mt-2 uppercase">
                  Vi er altid klar til at hjælpe
                </h2>
                <p className="mt-4 text-sm text-gray-600 leading-relaxed">
                  Uanset om du har brug for en mindre udgravning til en tilbygning eller etablering af en stor sandpude til et nyt parcelhus, er vi klar med professionel rådgivning.
                </p>
              </div>

              <div className="divide-y divide-gray-100 border-y border-gray-100">
                {/* Phone */}
                <div className="flex items-start gap-4 py-5">
                  <div className="text-brand-charcoal shrink-0 mt-0.5">
                    <Phone className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500">Telefon</h3>
                    <a
                      href={`tel:${companyInfo.phone}`}
                      className="text-base font-bold text-brand-charcoal hover:text-brand-accent transition-colors block mt-1 whitespace-nowrap"
                    >
                      {companyInfo.phoneFormatted}
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4 py-5">
                  <div className="text-brand-charcoal shrink-0 mt-0.5">
                    <Mail className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500">E-mail</h3>
                    <a
                      href={`mailto:${companyInfo.email}`}
                      className="text-base font-bold text-brand-charcoal hover:text-brand-accent transition-colors block mt-1 whitespace-nowrap"
                    >
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4 py-5">
                  <div className="text-brand-charcoal shrink-0 mt-0.5">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500">Adresse</h3>
                    <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                      {companyInfo.address}
                      <br />
                      {companyInfo.zipCity}
                    </p>
                  </div>
                </div>

                {/* CVR */}
                <div className="flex items-start gap-4 py-5">
                  <div className="text-brand-charcoal shrink-0 mt-0.5">
                    <Shield className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500">Virksomhedsoplysninger</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      CVR-nr: {companyInfo.cvr}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="lg:col-span-7">
              <div className="space-y-4">
                <h2 className="font-display text-2xl font-bold text-brand-charcoal sm:text-3xl uppercase">
                  Udfyld formularen
                </h2>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Udfyld felterne nedenfor med dine kontaktoplysninger og en kort beskrivelse af din opgave, så vender vi hurtigt tilbage.
                </p>
                <div className="pt-4">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
